import React, { useState } from 'react';
import classNames from 'classnames';
import iconQuestion from '../../assets/images/icon_questionmark.svg';
import css from './info.scss';
import InfoIcon from '../../components/icon-info/info-icon';
import { useInfoText } from './info-hooks';

const Info = () => {
  const [showTip, setShowTip] = useState(false);
  const [infoText] = useInfoText();

  const infoIconData = {
    icon: iconQuestion,
    paragraph: infoText(),
    showTip,
    onClick: e => setShowTip(e ? !showTip : false)
  };

  return (
    <InfoIcon
      className={classNames(css['info-icon'], { [css['info-icon-active']]: showTip })}
      infoIconData={infoIconData}
    />
  );
};


export default Info;
